import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminSearchBar from "../../components/AdminSideComponents/AdminSearchBar";
import { FaRegEdit } from "react-icons/fa";
import { MdDeleteOutline } from "react-icons/md";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import toast from "react-hot-toast";
import axiosInstance from "../../utils/axios";
import DeleteSeriveModal from "../../components/AdminSideComponents/Modals/DeleteServiceModal";
// import AddServiceModal from "../../components/AdminSideComponents/Modals/AddServiceModal";
// import EditServiceModal from "../../components/AdminSideComponents/Modals/EditServiceModal";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const handlePrevious = () => {
    if (currentPage > 1) onPageChange(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) onPageChange(currentPage + 1);
  };

  if (totalPages <= 1) return null;

  return (
    <div className="flex justify-center items-center space-x-4 my-10">
      <button
        disabled={currentPage === 1}
        onClick={handlePrevious}
        className={`px-4 py-3 rounded-lg text-white transition-all duration-300 transform ${
          currentPage === 1
            ? "bg-primaryFadedColor cursor-not-allowed"
            : "bg-primaryBtnColor hover:bg-primaryBtnHoverColor hover:scale-105 shadow-lg hover:shadow-xl"
        }`}
      >
        <FaAngleLeft />
      </button>

      <span className="text-sm font-medium text-gray-700 px-4 py-2 bg-gray-100 rounded-lg">
        {currentPage} of {totalPages}
      </span>

      <button
        disabled={currentPage === totalPages}
        onClick={handleNext}
        className={`px-4 py-3 rounded-lg text-white transition-all duration-300 transform ${
          currentPage === totalPages
            ? "bg-primaryFadedColor cursor-not-allowed"
            : "bg-primaryBtnColor hover:bg-primaryBtnHoverColor hover:scale-105 shadow-lg hover:shadow-xl"
        }`}
      >
        <FaAngleRight />
      </button>
    </div>
  );
};

const ServiceLoader = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {[...Array(4)].map((_, i) => (
        <div
          key={i}
          className="bg-white rounded-xl shadow-md overflow-hidden w-full flex flex-col border border-gray-100"
        >
          <div className="flex flex-col sm:flex-row w-full">
            {/* Image placeholder */}
            <div className="sm:w-2/3 h-full sm:h-auto relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-shimmer" />
            </div>
            <div className="flex flex-col w-full">
              {/* Content placeholder */}
              <div className="sm:w-full p-6 space-y-4 flex flex-col">
                <div className="h-6 bg-gray-200 rounded w-3/4 animate-pulse" />
                <div className="h-4 bg-gray-200 rounded w-full animate-pulse" />
                <div className="h-4 bg-gray-200 rounded w-5/6 animate-pulse" />
                <div className="h-4 bg-gray-200 rounded w-2/3 animate-pulse" />
              </div>
              <div className="flex w-full justify-end gap-3 p-6 border-t border-gray-100">
                <div className="w-10 h-10 bg-gray-200 rounded-lg animate-pulse" />
                <div className="w-10 h-10 bg-gray-200 rounded-lg animate-pulse" />
              </div>
            </div>
          </div>

          {/* Action buttons placeholder */}
        </div>
      ))}
    </div>
  );
};

const AdminServices = () => {
  const navigate = useNavigate();

  //pagination
  const ITEMS_PER_PAGE = 4;
  const [currentPage, setCurrentPage] = useState(1);
  //servive,loading and error
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  //modal-state-edit
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState(null);

  //modal-state-delete
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [deleteLoading, setdeleteLoading] = useState(false);
  const [serviceToDelete, setServiceToDelete] = useState(null);

  // search functionality state
  const [searchTerm, setSearchTerm] = useState("");
  const [FilterServices, setFilteredServices] = useState([]);

  //modal-add-state
  // const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  const totalPages = Math.ceil(FilterServices.length / ITEMS_PER_PAGE);
  const paginatedService = FilterServices.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const getServicesData = async () => {
    try {
      const response = await axiosInstance.get("/services/all-services");
      setServices(response.data);
      setFilteredServices(response.data);
      setError(false);
    } catch (error) {
      toast.error("Failed to fetch services", { id: "feildfetch" });
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmDelete = async () => {
    setdeleteLoading(true);
    const deletingToast = toast.loading("Deleting service...");
    try {
      await axiosInstance.delete(
        `/services/delete-service/${serviceToDelete._id}`
      );
      setServices((prev) => prev.filter((s) => s._id !== serviceToDelete._id));
      toast.success("Service deleted successfully", { id: deletingToast });
      getServicesData();
    } catch (error) {
      toast.error("Failed to delete service. Please try again.", {
        id: deletingToast,
      });
    } finally {
      setdeleteLoading(false);
      setIsDeleteModal(false);
      setServiceToDelete(null);
    }
  };

  useEffect(() => {
    getServicesData();
  }, []);

  const onSearchHandler = (query) => {
    console.log("query :", query);
    setSearchTerm(query);
    const lowerCaseQuery = query.trim().toLowerCase();
    const results = services.filter((s) =>
      s.serviceName.toLowerCase().includes(lowerCaseQuery)
    );
    setFilteredServices(results);
    setCurrentPage(1);
  };

  const onAddNewHandler = () => {
    // setIsAddModalOpen(true);
    navigate(`/create-admin-service`);
  };

  // Navigate to service details page
  const handleServiceClick = (serviceId) => {
    navigate(`/admin-service-details/${serviceId}`);
  };

  return (
    <div>
      <AdminSearchBar
        title={"All Services"}
        onAddNewClick={onAddNewHandler}
        onSearchClick={onSearchHandler}
      />

      <div className="py-4 mt-8 px-4 md:px-8 xl:px-[5rem]">
        {loading ? (
          <ServiceLoader />
        ) : error ? (
          <div className="text-center py-12">
            <div className="bg-red-50 border border-red-200 rounded-xl p-8 max-w-md mx-auto">
              <div className="text-red-500 text-6xl mb-4">⚠️</div>
              <h3 className="text-red-600 font-semibold text-xl mb-2">
                Unable to Load Services
              </h3>
              <p className="text-red-500 text-sm">
                Please check your connection and try again later.
              </p>
            </div>
          </div>
        ) : FilterServices.length === 0 ? (
          <div className="text-center py-12">
            <div className="bg-gray-50 border border-gray-200 rounded-xl p-8 max-w-md mx-auto">
              <div className="text-gray-400 text-6xl mb-4">📋</div>
              <h3 className="text-gray-600 font-semibold text-xl mb-2">
                No Services Found
              </h3>
              <p className="text-gray-500 text-sm">
                {searchTerm
                  ? `No results found for "${searchTerm}"`
                  : "No services available at the moment."}
              </p>
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {paginatedService.map((service) => (
              <div
                key={service._id}
                className="group bg-white rounded-xl shadow-md hover:shadow-2xl overflow-hidden transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 hover:border-blue-200 relative cursor-pointer h-[280px]" // Fixed height
                onClick={() => handleServiceClick(service._id)}
              >
                {/* Subtle gradient overlay for premium feel */}
                <div className="absolute inset-0 bg-gradient-to-r from-blue-500/0 to-purple-500/0 group-hover:from-blue-500/5 group-hover:to-purple-500/5 transition-all duration-300 rounded-xl pointer-events-none" />

                <div className="flex flex-col sm:flex-row h-full relative z-10">
                  {/* Enhanced image section - Fixed dimensions */}
                  <div className="sm:w-1/2 h-48 sm:h-full relative overflow-hidden flex-shrink-0">
                    {service.images && service.images.length > 0 ? (
                      <>
                        <img
                          src={service.images[0]}
                          alt={service.serviceName}
                          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                      </>
                    ) : (
                      <div className="w-full h-full bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center text-sm text-gray-500 relative">
                        <div className="text-center">
                          <div className="text-3xl mb-2 opacity-50">🖼️</div>
                          <span className="text-xs">No Image Available</span>
                        </div>
                        <div className="absolute inset-0 bg-gradient-to-br from-blue-500/10 to-purple-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                      </div>
                    )}
                  </div>

                  {/* Enhanced content section - Structured layout */}
                  <div className="sm:w-1/2 flex flex-col h-full">
                    {/* Main content area */}
                    <div className="flex-1 p-4 flex flex-col">
                      {/* Title section - Fixed height */}
                      <div className="mb-3">
                        <h2 className="text-lg font-bold line-clamp-2 h-14 text-primaryDark group-hover:text-blue-600 transition-colors duration-300 leading-tight overflow-hidden">
                          {service.serviceName}
                        </h2>
                      </div>

                      {/* Description section - Flexible but contained */}
                      <div className="flex-1 mb-3 max-h-28 ">
                        {service.description &&
                        service.description.length > 0 ? (
                          <div className="bg-gray-50 p-3 rounded-lg group-hover:bg-blue-50/50 transition-colors duration-300 h-full flex flex-col">
                            <h3 className="text-sm font-semibold text-gray-800 mb-2 line-clamp-1">
                              {service.description[0]?.heading}
                            </h3>
                            <p className="text-xs text-gray-600 line-clamp-3 leading-relaxed flex-1">
                              {service.description[0]?.content}
                            </p>
                          </div>
                        ) : (
                          <div className="bg-gray-50 p-3 rounded-lg h-full flex items-center justify-center">
                            <p className="text-xs text-gray-500 italic">
                              No description available.
                            </p>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Action buttons - Fixed at bottom */}
                    <div className="flex justify-end gap-3 p-4 pt-0">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/edit-admin-service/${service._id}`);
                        }}
                        className="flex items-center justify-center w-10 h-10 text-blue-600 hover:text-white bg-blue-50 hover:bg-blue-600 rounded-lg transition-all duration-300 transform hover:scale-110 hover:shadow-lg group/btn"
                        title="Edit Service"
                      >
                        <FaRegEdit className="size-4 transition-transform duration-200 group-hover/btn:rotate-12" />
                      </button>

                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setServiceToDelete(service);
                          setIsDeleteModal(true);
                        }}
                        className="flex items-center justify-center w-10 h-10 text-red-600 hover:text-white bg-red-50 hover:bg-red-600 rounded-lg transition-all duration-300 transform hover:scale-110 hover:shadow-lg group/btn"
                        title="Delete Service"
                      >
                        <MdDeleteOutline className="size-5 transition-transform duration-200 group-hover/btn:rotate-12" />
                      </button>
                    </div>
                  </div>
                </div>

                {/* Subtle shine effect */}
                <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-white/10 to-transparent -skew-x-12 translate-x-[-200%] group-hover:translate-x-[200%] transition-transform duration-1000 pointer-events-none" />
              </div>
            ))}
          </div>
        )}
      </div>

      <Pagination
        currentPage={currentPage}
        onPageChange={setCurrentPage}
        totalPages={totalPages}
      />

      {/* modal for delete  */}
      {isDeleteModal && serviceToDelete && (
        <DeleteSeriveModal
          itemName={serviceToDelete.serviceName}
          loading={deleteLoading}
          onClose={() => {
            setIsDeleteModal(false);
            setServiceToDelete(null);
          }}
          onConfirm={handleConfirmDelete}
        />
      )}
      {/* modal for the edit */}
      {/* {isModalOpen && selectedService && (
        <EditServiceModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          serviceData={selectedService}
          onUpdate={() => {
            getServicesData();
            setIsModalOpen(false);
            setServiceToDelete(null);
          }}
        />
      )} */}
      {/* modal for add new 
      {isAddModalOpen && (
        <AddServiceModal
          onClose={() => setIsAddModalOpen(false)}
          onSuccess={() => {
            getServicesData();
            setIsAddModalOpen(false);
          }}
          onUpdate={() => {
            getServicesData();
            setIsAddModalOpen(false);
            setServiceToDelete(null);
          }}
        />
      )} */}
    </div>
  );
};

export default AdminServices;
